<template>
  <el-dialog :append-to-body="true" :visible.sync="value" :show-close="false" width="550px" custom-class="public-pool-drop-actived-dialog" @closed="closed" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="head">
      <h1 class="title">请选择时间</h1>
      <i class="el-icon-close" style="cursor: pointer;" @click="closed"></i>
    </div>
    <p class="dialogDesc">您可以选择在每周的某一天客户不会触发「因超时未跟进」而自动掉落到公客池时，您可以使用此配置功能。</p>
    <p class="dialogTitle">每天休息时间（选择的时间段不允许重叠）</p>
    <div class="time-group">
      <div class="time-con" v-for="(time, i) in times" :key="i">
        <el-time-picker v-model="time['timeStart']" placeholder="请选择时间" size="small" class="time-item" :picker-options="{format: 'HH:mm'}" value-format="HH:mm" format="HH:mm"></el-time-picker>
        <span class="time-range">至</span>
        <el-time-picker v-model="time['timeEnd']" placeholder="请选择时间" size="small" class="time-item" :picker-options="{format: 'HH:mm'}" value-format="HH:mm" format="HH:mm"></el-time-picker>
      </div>
    </div>
    <p class="dialogTitle">公休日</p>
    <div class="week-group">
      <el-checkbox-group v-model="weeks">
        <el-checkbox :label="date.id" v-for="(date, i) in list" :key="i">{{date.name}}</el-checkbox>
      </el-checkbox-group>
      <div class="button-con">
        <el-button size="small" @click="closed">取消</el-button>
        <el-button size="small" @click="clear">清空全部时间</el-button>
        <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
    export default{
        name: 'PublicPoolDatePicker',
        data () {
            return {
                value: false,
                times: [
                    {timeStart: '', timeEnd: ''},
                    {timeStart: '', timeEnd: ''},
                    {timeStart: '', timeEnd: ''}
                ],
                weeks: [],
                list: [
                    {id: 1, name: '每周一整天'},
                    {id: 2, name: '每周二整天'},
                    {id: 3, name: '每周三整天'},
                    {id: 4, name: '每周四整天'},
                    {id: 5, name: '每周五整天'},
                    {id: 6, name: '每周六整天'},
                    {id: 7, name: '每周日整天'},
                ]
            }
        },
        methods: {
            open (data) {
                this.value = true;
                // 解析时间范围数据
                if (data) {
                    const times = JSON.parse(data.unconfirmed_daily_protect_time_json || '[]');
                    this.times = this.times.map((v, i) => {
                        return {timeStart: times[i] ? times[i][0] : '', timeEnd: times[i] ? times[i][1] : ''};
                    });
                    this.weeks = data.unconfirmed_weekly_protect_time ? data.unconfirmed_weekly_protect_time.split(',').map(v => +v) : this.weeks;
                }
            },
            closed () {
                this.value = false;
                this.clear();
            },
            clear () {
                this.times = [
                    {timeStart: '', timeEnd: ''},
                    {timeStart: '', timeEnd: ''},
                    {timeStart: '', timeEnd: ''}
                ];
                this.weeks = [];
            },
            handleConfirm () {
                // 解析每天休息时间：1.不允许选择重叠的时间 2.每天休息时间总计不能超过12小时
                let $count = 0;
                for (let i = 0; i < this.times.length; i ++) {
                    const item = this.times[i];
                    if ((item.timeStart && !item.timeEnd) || (!item.timeStart && item.timeEnd)) {
                        this.$message.error('开始时间与结束时间必须同时选择!');
                        return null;
                    }
                    if (item.timeStart && item.timeEnd) {
                        const count = this.getTimeDiff(item.timeStart, item.timeEnd);
                        if (count <= 0) {
                            this.$message.error('开始时间必须早于结束时间!');
                            return null;
                        }
                        $count += count;
                    }
                }
                if ($count >= 72000) {
                    this.$message.error('每天休息时间总计不能超过20小时!');
                    return null;
                }
                const $overlay = this.hasRangeOverlap(this.times[0], this.times[1]) || this.hasRangeOverlap(this.times[0], this.times[2]) || this.hasRangeOverlap(this.times[1], this.times[2]);
                if ($overlay) {
                    this.$message.error('每天休息时间所选时间段重叠，请修改后再提交!');
                    return null;
                }
                // 解析周选择：1.不能选择7天
                if(this.weeks.length == 7){
                    this.$message.error('当前设置会导致客户永远不会因为【未及时跟进掉公客池】，请重新配置');
                    return null;
                }
                const weekIds = this.weeks.join(',');
                const timeRange = [];
                this.times.map(v => {
                    if (v.timeStart && v.timeEnd) {
                        timeRange.push([v.timeStart, v.timeEnd]);
                    }
                })
                console.log(JSON.stringify(timeRange))
                this.$emit('confirm', {
                    unconfirmed_daily_protect_time_json: JSON.stringify(timeRange),
                    unconfirmed_weekly_protect_time: weekIds
                })
                this.closed();
            },
            // 获取两个时间之前的差值
            getTimeDiff (timeS, timeE) {
                const start = Date.parse('1970-01-01T' + timeS + 'Z');
                const end = Date.parse('1970-01-01T' + timeE + 'Z');
                return Math.round((end - start) / 1000);
            },
            // 判断两个时间是否有重叠
            hasRangeOverlap (range, range1) {
                if (!range.timeStart || !range.timeEnd || !range1.timeStart || !range1.timeEnd) return false;
                if (range.timeEnd <= range1.timeStart) return false;
                if (range1.timeEnd <= range.timeStart) return false;
                return true;
            },
            timeToSec (time) {
                if (time) {
                    const s = '';
                    const hour = time.split(':')[0];
                    const min = time.split(':')[1];
                    return Number(hour * 3600) + Number(min * 60);
                }
            }
        },
    }
</script>
<style lang="less">
.public-pool-drop-actived-dialog{
    .dialogDesc{
        color: #999999;
        padding: 10px 20px;
        line-height: 20px;
        font-size: 13px;
    }
    .dialogTitle{
        color: #000000;
        font-size: 16px;
        padding: 10px 20px;
    }
    .time-group{
        padding: 10px 20px;
        .time-con{
            .box();
            -webkit-box-pack: start;
            margin-bottom: 15px;
            &:last-child{
                margin-bottom: 0;
            }
        }
        .time-item{
            width: 170px;
        }
        .time-type{
            width: 100px;
            margin-right: 10px;
        }
        .time-range{
            font-size: 13px;
            color: #333;
            display: block;
            padding: 0 10px;
        }
    }
    .button-con{
        text-align: center;
        margin-top: 40px;
        button{
            width: 100px;
            text-align: center;
        }
    }
    .week-group{
        padding-left: 30px;
        padding-bottom: 20px;
        .el-checkbox{
            margin-top: 10px;
        }
        .tips{
            margin-top: 20px;
            color: #666;
            font-size: 13px;
        }
        .button-con{
            text-align: center;
            margin-top: 40px;
            button{
                width: 100px;
                text-align: center;
            }
        }
    }
}
</style>
